class SliderElement extends HTMLElement {
    constructor() {
      super();
      this.slider = this.querySelector('[id^="Slider-"]');
      this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
      this.speed = parseInt(this.slider.getAttribute('data-speed')) * 1000;
      if (!this.slider ) return;
      if(this.slider.querySelectorAll('.gallery-cell').length > 1){
        this.initPages();
      }
    }
  
    initPages() {
        var flkty = new Flickity( this.slider, {
            cellAlign: 'left',
            draggable: true,
            contain: true,
            autoPlay: this.speed,
            wrapAround: true,
            arrowShape: "M 10,50 L 60,100 L 62,90 L 22,50  L 62,10 L 60,0 Z"
        });      
    }
  
  }
  
customElements.define('carousel-component', SliderElement);
  